document.addEventListener('DOMContentLoaded', () => {
  const calculators = document.querySelectorAll('[data-size-calculator]');
  if (!calculators.length) return;

  for (const calculator of calculators) {
    const source = calculator.querySelector('[data-size-calculator-source]');
    const inputsContainer = calculator.querySelector('[data-size-calculator-inputs]');
    const result = calculator.querySelector('[data-size-calculator-result]');
    const category = calculator.getAttribute('data-size-calculator-category');
    const unitToggle = calculator.querySelector('[data-size-calculator-unit-toggle]');
    let activeUnit = 'cm';

    if (!source || !inputsContainer || !result || !category) continue;

    const parser = new DOMParser();
    const doc = parser.parseFromString(source.innerHTML, 'text/html');

    if (category === 'briefs') {
      const briefsData = parseBriefsData(doc) || getFallbackBriefsData();
      if (!briefsData) continue;
      renderBriefsCalculator(calculator, inputsContainer, result, briefsData, () => activeUnit);
      bindUnitToggle(unitToggle, (unit) => {
        activeUnit = unit;
        inputsContainer.dispatchEvent(new CustomEvent('size-calculator-update'));
      });
      continue;
    }

    const cupData = parseCupData(doc, category) || getFallbackCupData(category);
    if (!cupData) continue;
    renderCupCalculator(calculator, inputsContainer, result, cupData, () => activeUnit);
    bindUnitToggle(unitToggle, (unit) => {
      activeUnit = unit;
      inputsContainer.dispatchEvent(new CustomEvent('size-calculator-update'));
    });
  }
});

function cleanText(value) {
  return (value || '').replace(/\s+/g, ' ').trim();
}

function parseCupData(doc, category) {
  const groups = doc.querySelectorAll('.size-guide-group');
  const targetGroup = Array.from(groups).find((group) => {
    const heading = group.querySelector('h3');
    if (!heading) return false;
    const headingText = cleanText(heading.textContent).toLowerCase();
    if (category === 'bralette') return headingText.includes('bralette');
    return headingText.includes('cami') || headingText.includes('bodysuit') || headingText.includes('pj top');
  });

  if (!targetGroup) return null;

  const inchesTable = targetGroup.querySelector('.in-table');
  const cmTable = targetGroup.querySelector('.cm-table');
  if (!inchesTable && !cmTable) return null;

  const inData = inchesTable ? parseCupTable(inchesTable) : null;
  const cmData = cmTable ? parseCupTable(cmTable) : null;
  const cups = inData ? inData.cups : (cmData ? cmData.cups : []);
  if (!cups.length) return null;

  return {
    cups,
    inData: inData || { underbusts: [], matrix: {} },
    cmData: cmData || { underbusts: [], matrix: {} },
  };
}

function parseBriefsData(doc) {
  const groups = doc.querySelectorAll('.size-guide-group');
  const targetGroup = Array.from(groups).find((group) => {
    const heading = group.querySelector('h3');
    if (!heading) return false;
    const headingText = cleanText(heading.textContent).toLowerCase();
    return headingText.includes('brief') || headingText.includes('pj bottom');
  });

  if (!targetGroup) return null;

  const inchesTable = targetGroup.querySelector('.in-table');
  const cmTable = targetGroup.querySelector('.cm-table');
  if (!inchesTable && !cmTable) return null;

  const inOptions = inchesTable ? parseBriefsTable(inchesTable) : [];
  const cmOptions = cmTable ? parseBriefsTable(cmTable) : [];
  if (!inOptions.length && !cmOptions.length) return null;

  return {
    inOptions,
    cmOptions,
  };
}

function getFallbackCupData(category) {
  const baseUnderbusts = ['25 - 30', '29.5 - 32', '31 - 33', '32 - 35', '34 - 37'];
  const braletteCups = ['A', 'B', 'C', 'D', 'DD', 'E'];
  const camiCups = ['A', 'B', 'C', 'D', 'DD', 'E', 'F', 'G'];

  if (category === 'bralette') {
    return {
      cups: braletteCups,
      inData: {
        underbusts: baseUnderbusts,
        matrix: {
          '25 - 30': { A: 'S', B: 'S', C: 'S', D: 'M', DD: 'M', E: 'M' },
          '29.5 - 32': { A: 'M', B: 'M', C: 'M', D: 'L', DD: 'L', E: 'L' },
          '31 - 33': { A: 'L', B: 'L', C: 'L', D: 'XL', DD: 'XL', E: 'XL' },
          '32 - 35': { A: 'XL', B: 'XL', C: 'XL', D: 'XXL', DD: 'XXL', E: 'XXL' },
          '34 - 37': { A: '-', B: 'XL', C: 'XXL', D: 'XXL', DD: 'XXL', E: '-' },
        },
      },
      cmData: {
        underbusts: ['64 - 77', '75 - 81', '78 - 84', '82 - 88', '86 - 94'],
        matrix: {
          '64 - 77': { A: 'S', B: 'S', C: 'S', D: 'M', DD: 'M', E: 'M' },
          '75 - 81': { A: 'M', B: 'M', C: 'M', D: 'L', DD: 'L', E: 'L' },
          '78 - 84': { A: 'L', B: 'L', C: 'L', D: 'XL', DD: 'XL', E: 'XL' },
          '82 - 88': { A: 'XL', B: 'XL', C: 'XL', D: 'XXL', DD: 'XXL', E: 'XXL' },
          '86 - 94': { A: '-', B: 'XL', C: 'XXL', D: 'XXL', DD: 'XXL', E: '-' },
        },
      },
    };
  }

  return {
    cups: camiCups,
    inData: {
      underbusts: baseUnderbusts,
      matrix: {
        '25 - 30': { A: 'S', B: 'S', C: 'S', D: 'M', DD: 'M', E: 'M', F: '-', G: '-' },
        '29.5 - 32': { A: 'M', B: 'M', C: 'M', D: 'L', DD: 'L', E: 'L', F: 'L', G: '-' },
        '31 - 33': { A: 'L', B: 'L', C: 'L', D: 'XL', DD: 'XL', E: 'XL', F: 'XL', G: 'XL' },
        '32 - 35': { A: 'XL', B: 'XL', C: 'XL', D: 'XXL', DD: 'XXL', E: 'XXL', F: 'XXL', G: 'XXL' },
        '34 - 37': { A: '-', B: 'XL', C: 'XXL', D: 'XXL', DD: 'XXL', E: 'XXL', F: '-', G: '-' },
      },
    },
    cmData: {
      underbusts: ['64 - 77', '75 - 81', '78 - 84', '82 - 88', '86 - 94'],
      matrix: {
        '64 - 77': { A: 'S', B: 'S', C: 'S', D: 'M', DD: 'M', E: 'M', F: '-', G: '-' },
        '75 - 81': { A: 'M', B: 'M', C: 'M', D: 'L', DD: 'L', E: 'L', F: 'L', G: '-' },
        '78 - 84': { A: 'L', B: 'L', C: 'L', D: 'XL', DD: 'XL', E: 'XL', F: 'XL', G: 'XL' },
        '82 - 88': { A: 'XL', B: 'XL', C: 'XL', D: 'XXL', DD: 'XXL', E: 'XXL', F: 'XXL', G: 'XXL' },
        '86 - 94': { A: '-', B: 'XL', C: 'XXL', D: 'XXL', DD: 'XXL', E: 'XXL', F: '-', G: '-' },
      },
    },
  };
}

function getFallbackBriefsData() {
  return {
    inOptions: [
      { size: 'S', hips: '35.8 - 38.2', waist: '28.0 - 29.9' },
      { size: 'M', hips: '38.2 - 40.2', waist: '29.1 - 31.5' },
      { size: 'L', hips: '40.2 - 42.5', waist: '31.5 - 33.1' },
      { size: 'XL', hips: '42.5 - 44.9', waist: '33.1 - 35.4' },
      { size: 'XXL', hips: '44.9 - 47.2', waist: '35.4 - 37.8' },
    ],
    cmOptions: [
      { size: 'S', hips: '91 - 97', waist: '71 - 76' },
      { size: 'M', hips: '97 - 102', waist: '74 - 80' },
      { size: 'L', hips: '102 - 108', waist: '80 - 84' },
      { size: 'XL', hips: '108 - 114', waist: '84 - 90' },
      { size: 'XXL', hips: '114 - 120', waist: '86 - 96' },
    ],
  };
}

function buildField(labelText, values, idPrefix) {
  const field = document.createElement('div');
  field.className = 'product-size-calculator__field';

  const label = document.createElement('label');
  label.className = 'product-size-calculator__label';

  const select = document.createElement('select');
  select.className = 'product-size-calculator__select';
  select.id = `${idPrefix}-${Math.random().toString(36).slice(2, 8)}`;

  label.setAttribute('for', select.id);
  label.textContent = labelText;

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = `Select ${labelText}`;
  placeholder.selected = true;
  placeholder.disabled = true;
  select.appendChild(placeholder);

  for (const value of values) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = value;
    select.appendChild(option);
  }

  field.appendChild(label);
  field.appendChild(select);

  return { field, select };
}

function renderCupCalculator(calculator, container, result, data, getActiveUnit) {
  container.innerHTML = '';
  const underbustField = buildField('Underbust', [], 'underbust');
  const cupField = buildField('Cup', data.cups, 'cup');
  container.appendChild(underbustField.field);
  container.appendChild(cupField.field);

  const populateUnderbust = () => {
    const unit = getActiveUnit() === 'cm' ? 'cm' : 'in';
    const unitData = unit === 'cm' ? data.cmData : data.inData;
    setSelectOptions(underbustField.select, unitData.underbusts, `Select Underbust (${unit.toUpperCase()})`);
  };

  const update = () => {
    const selectedUnderbust = cleanText(underbustField.select.value);
    const selectedCup = cleanText(cupField.select.value);
    const unit = getActiveUnit() === 'cm' ? 'cm' : 'in';
    const unitData = unit === 'cm' ? data.cmData : data.inData;
    const unitLabel = unit.toUpperCase();

    if (!selectedUnderbust || !selectedCup) {
      result.hidden = true;
      result.textContent = '';
      return;
    }

    const mappedSize =
      unitData.matrix[selectedUnderbust] && unitData.matrix[selectedUnderbust][selectedCup]
        ? unitData.matrix[selectedUnderbust][selectedCup]
        : '-';
    result.hidden = false;

    if (mappedSize === '-') {
      result.textContent = 'No matching size available for this combination.';
      return;
    }

    result.textContent = `Fits Size ${mappedSize}`;
    selectProductSizeOption(calculator, mappedSize);
  };

  underbustField.select.addEventListener('change', update);
  cupField.select.addEventListener('change', update);
  container.addEventListener('size-calculator-update', populateUnderbust);
  container.addEventListener('size-calculator-update', update);
  populateUnderbust();
  update();
}

function renderBriefsCalculator(calculator, container, result, data, getActiveUnit) {
  container.innerHTML = '';
  const hipsField = buildField('Hips', [], 'hips');
  container.appendChild(hipsField.field);

  const populateHips = () => {
    const unit = getActiveUnit() === 'cm' ? 'cm' : 'in';
    const options = unit === 'cm' ? data.cmOptions : data.inOptions;
    const hipsValues = options.map((item) => item.hips);
    setSelectOptions(hipsField.select, hipsValues, `Select Hips (${unit.toUpperCase()})`);
  };

  const update = () => {
    const unit = getActiveUnit() === 'cm' ? 'cm' : 'in';
    const options = unit === 'cm' ? data.cmOptions : data.inOptions;
    const unitLabel = unit.toUpperCase();
    const hips = cleanText(hipsField.select.value);

    if (!hips) {
      result.hidden = true;
      result.textContent = '';
      return;
    }

    const match = options.find((item) => item.hips === hips);
    if (!match) {
      result.hidden = false;
      result.textContent = 'No matching size available for this combination.';
      return;
    }

    result.hidden = false;
    result.textContent = `Fits Size ${match.size}`;
    selectProductSizeOption(calculator, match.size);
  };

  hipsField.select.addEventListener('change', update);
  container.addEventListener('size-calculator-update', populateHips);
  container.addEventListener('size-calculator-update', update);
  populateHips();
  update();
}

function parseCupTable(table) {
  const theadRows = Array.from(table.querySelectorAll('thead tr'));
  const headerRow = theadRows.length ? theadRows[theadRows.length - 1] : null;
  if (!headerRow) return { cups: [], underbusts: [], matrix: {} };

  let cupLabels = Array.from(headerRow.querySelectorAll('th')).map((cell) => cleanText(cell.textContent));
  if (cupLabels.length && /underbust/i.test(cupLabels[0])) {
    cupLabels = cupLabels.slice(1);
  }
  const cups = cupLabels.filter((label) => label && !/^cup$/i.test(label));
  const rows = Array.from(table.querySelectorAll('tbody tr')).map((row) =>
    Array.from(row.querySelectorAll('td')).map((cell) => cleanText(cell.textContent))
  );

  const underbusts = [];
  const matrix = {};
  for (const row of rows) {
    if (row.length < 2) continue;
    const underbust = row[0];
    underbusts.push(underbust);
    matrix[underbust] = {};
    cups.forEach((cup, idx) => {
      matrix[underbust][cup] = row[idx + 1] || '-';
    });
  }

  return { cups, underbusts, matrix };
}

function parseBriefsTable(table) {
  const rows = Array.from(table.querySelectorAll('tbody tr')).map((row) =>
    Array.from(row.querySelectorAll('td')).map((cell) => cleanText(cell.textContent))
  );

  return rows
    .filter((row) => row.length >= 3)
    .map((row) => ({
      size: row[0],
      hips: row[1],
      waist: row[2],
    }));
}

function bindUnitToggle(toggle, onChange) {
  if (!toggle) return;
  toggle.addEventListener('change', () => {
    onChange(toggle.checked ? 'in' : 'cm');
  });
}

function setSelectOptions(select, values, placeholderText) {
  const currentValue = select.value;
  select.innerHTML = '';

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = placeholderText;
  placeholder.selected = true;
  placeholder.disabled = true;
  select.appendChild(placeholder);

  for (const value of values) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = value;
    select.appendChild(option);
  }

  if (currentValue && values.includes(currentValue)) {
    select.value = currentValue;
  }
}

function selectProductSizeOption(calculator, sizeValue) {
  if (!sizeValue || sizeValue === '-') return;

  const scope = calculator.closest('product-info') || document;
  const normalizedTarget = normalizeSizeValue(sizeValue);

  const radioInputs = Array.from(scope.querySelectorAll('variant-radios input[name="Size"]'));
  const matchingRadio = radioInputs.find((input) => normalizeSizeValue(input.value) === normalizedTarget);
  if (matchingRadio && !matchingRadio.checked) {
    matchingRadio.checked = true;
    matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  const sizeSelect = scope.querySelector('variant-selects select[name="options[Size]"]:not(.product-form__color-select-hidden)');
  if (!sizeSelect) return;

  const matchingOption = Array.from(sizeSelect.options).find(
    (option) => normalizeSizeValue(option.value) === normalizedTarget
  );
  if (!matchingOption || sizeSelect.value === matchingOption.value) return;

  sizeSelect.value = matchingOption.value;
  sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
}

function normalizeSizeValue(value) {
  return cleanText(value).toUpperCase().replace(/\s+/g, '');
}
